import { useContext, useEffect, useState } from "react";
import AuthContext from "context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Form from "react-bootstrap/Form";
import { addOrUpdateList } from "core/utils/arrays";
import { SwalAlertClass } from "core/swalClass";
import axiApi from "ApiCaller";
import TabContainers from "./TabContainers";
import { subscribeEvent, unsubscribeEvent } from "core/eventsConnector";
import MapAssetsContainer from "site-apps/assets/components/MapAssetsContainer";
import ModalSelectAssetMultiple from "site-apps/assets/components/ModalSelectAssetMultiple";
import FormButton from "components/buttons/FormButton";
import useCustomTranslation from "core/customTranslation";
import { translations } from "../translations";

const PreviewGroup = ({ item, setItem, items, setItemsShow, setShowPrev, showPrev }) => {
    const { panel, user } = useContext(AuthContext);
    const [formData, setFormData] = useState({ ...item });
    const { t: _TC } = useCustomTranslation(translations);

    const canEdit = user && (user.is_superuser || user.is_admin);
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
    const [showModalAssets, setShowModalAssets] = useState(false);
    const [showMap, setShowMap] = useState(false);
    const [position, setPosition] = useState([parseFloat(item.lat), parseFloat(item.lng)]);
    const [assets, setAssets] = useState((item.actives || []).map(a => ({ ...a, lat: parseFloat(a.lat), lng: parseFloat(a.lng) })));
    const [isLoading, setIsLoading] = useState(false);

    const [activeTab, setActiveTab] = useState("data");

    const handleTabSelect = (tabKey) => {
        setActiveTab(tabKey);
        if (tabKey === "locations") {
            // Forzar el re-renderizado del mapa
            setShowMap(false);
            setTimeout(() => {
                setShowMap(true);
            }, 100);
        }
    };

    const onClickSelectAssets = () => {
        setShowModalAssets(true);
        subscribeEvent("assets:modal:selector", onSelectAssets);
    };

    function onSelectAssets(e) {
        setAssets(e.detail.assets.map(a => ({ ...a, lat: parseFloat(a.lat), lng: parseFloat(a.lng) })));
        unsubscribeEvent("assets:modal:selector", onSelectAssets);
    }

    // -
    const onSubmit = (e) => {
        setIsLoading(true);
        e.preventDefault();
        let form = new FormData(e.currentTarget);
        let assetsIds = [];
        assets.forEach((_asset) => {
            assetsIds.push(_asset.id);
        });
        form.set("assets", assetsIds.join(","));
        axiApi
            .post(`/api/assets/group/`, form)
            .then((resp) => {
                if (resp.data.status) {
                    if (formData.id) {
                        items.current.showed = addOrUpdateList(
                            items.current.showed,
                            resp.data.item
                        );
                    } else {
                        items.current.showed.push(resp.data.item);
                    }
                    setItemsShow([...items.current.showed]);
                    setItem(resp.data.item);
                    setShowPrev(false);
                    Alert.success(_TC("preview.saved"), _TC("preview.saved.success"));
                } else {
                    Alert.warning(_TC("preview.error"), _TC("preview.error.admin"));
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        setFormData({ ...item });
        setPosition([parseFloat(item.lat), parseFloat(item.lng)]);
        setAssets((item.actives || []).map(a => ({ ...a, lat: parseFloat(a.lat), lng: parseFloat(a.lng) })));
        setShowMap(showPrev);

        return () => {
            unsubscribeEvent("assets:modal:selector", onSelectAssets);
        };
    }, [item, showPrev]);

    return (
        <>
            <div
                className={showPrev ? "col preview-row" : "d-none"}
                style={{
                    width: "400px",
                    maxWidth: "400px",
                    height: "calc(100vh - 160px)",
                    overflow: "hidden",
                }}>
                <Form className="row" onSubmit={onSubmit}>
                    <input type="hidden" defaultValue={formData.id} name="id" />
                    <div className="col-12 p-0">
                        <div
                            className="preview-card"
                            style={{
                                width: "400px",
                                height: "calc(100vh - 160px)",
                                overflowY: "auto",
                            }}>
                            <div className="preview-header">
                                <div className="preview-icon">
                                    <FontAwesomeIcon icon="object-group" />
                                </div>
                                <div className="preview-title ms-3 d-flex align-items-center">
                                    <h3>
                                        {formData.id
                                            ? formData.name
                                            : _TC("preview.add")}
                                    </h3>
                                </div>
                            </div>
                            <Tabs
                                defaultActiveKey="data"
                                id="tabs-group"
                                className="mb-3"
                                activeKey={activeTab}
                                onSelect={handleTabSelect}>
                                <Tab
                                    eventKey="data"
                                    title={_TC("tab.data")}
                                    className="p-3">
                                    <div className="preview-item mt-3">
                                        <label htmlFor="name">
                                            {_TC("field.name")}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control mb-2"
                                            id="name"
                                            name="name"
                                            defaultValue={formData.name}
                                        />
                                    </div>
                                    {formData.counter ? (
                                        <div className="preview-item">
                                            <label>{_TC("field.containers")}</label>
                                            <div className="preview-input">
                                                {formData.counter}
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </Tab>
                                <Tab
                                    eventKey="containers"
                                    title={_TC("tab.containers")}>
                                    <TabContainers
                                        onClickSelectAssets={onClickSelectAssets}
                                        assets={assets}
                                    />
                                </Tab>
                                <Tab eventKey="locations" title={_TC("tab.locations")}>
                                    {showMap && activeTab === "locations" ? (
                                        <div className="preview-item">
                                            <MapAssetsContainer
                                                center={position}
                                                waypoints={assets}
                                            />
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </Tab>
                            </Tabs>

                            <div className="preview-item mt-3">
                                <div className="preview-input">
                                    <div className="d-flex justify-content-end mb-3">
                                        {canEdit ? (
                                            <FormButton
                                                type="submit"
                                                className="btn btn-primary"
                                                isProcessing={isLoading}>
                                                {_TC("button.save")}
                                            </FormButton>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
            {showModalAssets ? (
                <ModalSelectAssetMultiple
                    show={showModalAssets}
                    setShow={setShowModalAssets}
                    chosenIn={assets}
                    multiple={true}
                    subtitle={"Grupo: " + item.name}
                />
            ) : (
                <></>
            )}
        </>
    );
};

export default PreviewGroup;
